<template>
  <svg height="12" width="12" v-if="!$store.state.gamePause">
    <circle
      class="circle"
      cx="6"
      cy="6"
      r="5"
      stroke="#fff"
      stroke-width="2"
      fill-opacity="0"
      :style="cAnim"
      :class="animClass"
    />
  </svg>
</template>

<script>
export default {
  name: "Clocker",
  props: {},
  computed: {
    cAnim: function() {
      let duration =
        this.$store.state.intervalTime / 1000 / this.$store.state.timeMulti;
      return {
        "animation-duration": duration + "s",
      };
    },

    timeMulti: function() {
      return this.$store.state.timeMulti;
    },

    gamePause: function() {
      return this.$store.state.gamePause;
    },
    //  + 's'
  },
  data() {
    return {
      animClass: "animated",
    };
  },

  watch: {
    timeMulti: function() {
      this.restartClock();
    },

    gamePause: function() {
      this.restartClock();
    },
  },

  methods: {
    restartClock: function() {
      this.animClass = "";
      setTimeout(() => {
        this.animClass = "animated";
      }, 10);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.circle {
  stroke-dasharray: 32;
  stroke-dashoffset: 32;
  // animation: stroke 1s ease-out infinite;
}
.animated {
  animation-name: stroke;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

@keyframes stroke {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}
</style>
